module.exports = __webpack_public_path__ + "static/media/free-software-development-agreement.9d3c4a8a.doc";